
































import { Component, Vue, Provide, Prop } from 'vue-property-decorator';
import Invoice from '@/components/Invoicing/Invoice/Invoice.vue';
import { GET_INVOICE } from '@/queries/Invoice';
import cloneDeep from 'lodash/cloneDeep';
import { DocumentShowType } from '@/components/Invoicing/Shared/DocumentHeader.vue';
import { GQL_invoice_invoice } from '@/queries/__generated__/invoice';

@Component({
  components: {
    Invoice,
  },
})
export default class InvoicesPdf extends Vue {
  public GET_INVOICE = GET_INVOICE;
  public cloneDeep = cloneDeep;

  @Prop({ type: String, required: true }) private type!: DocumentShowType;
  @Prop({ type: String, default: null }) private maxDate!: string | null;
  @Provide() public isPdf = true;

  // We have to select only invoiceOvedueNotices which are up to the maxDate when printing pdf only
  private constrainInvoiceOverdueNotices(invoice: {invoice: GQL_invoice_invoice}): { invoice: GQL_invoice_invoice } {
    if (this.type === 'overdueNotice' && this.maxDate) {
      const maxDate = this.$dayjs.strict(this.maxDate);
      const constrainedNotices = invoice.invoice.invoiceOverdueNotices.filter(notice => this.$dayjs.strict(notice.issueDate).isSameOrBefore(maxDate));
      invoice.invoice.invoiceOverdueNotices = constrainedNotices;
    }
    return invoice;
  }
 }
